module.exports = __webpack_public_path__ + "static/media/stamp-1.6458943c.png";